import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import NoteDropTarget from 'notebook/notes/drag-and-drop/NoteDropTarget';
import {NOTE_EDITOR_MIN_HEIGHT} from 'notebook/notes/NoteConstants';
import {FromServerNoteLinkedFile} from 'notebook/util/NoteUtilConstants';
import {LinkedItem} from 'ui-library/attach-dropdown/AttachDropdownConstants';
import DropTargetClass from 'util/drag-and-drop/DropTarget';
import {ElementMouseEvent} from 'util/Types';

interface NoteCatcherProps {
  fileId: string;
  fullScreen: boolean;
  fullHeight?: boolean;
  hideTitle: boolean;
  insertItemHandler: (item: LinkedItem) => void;
  insertFilePlaceholderHandler: (
    taskIdAndDeferreds: Array<{taskId: string; fileUploadDeferred: JQueryPromise<FromServerNoteLinkedFile>}>
  ) => void;
  locked: boolean;
  dirty?: boolean;
  isProtected: boolean;
  onMouseDown?: (e: ElementMouseEvent) => void;
  selected: {index: number};
  setInsertIndex: (index: number | null) => void;
}

class NoteCatcher extends React.Component<NoteCatcherProps> {
  static propTypes = {
    fileId: PropTypes.string.isRequired,
    fullScreen: PropTypes.bool.isRequired,
    fullHeight: PropTypes.bool,
    hideTitle: PropTypes.bool.isRequired,
    insertItemHandler: PropTypes.func.isRequired,
    insertFilePlaceholderHandler: PropTypes.func.isRequired,
    locked: PropTypes.bool.isRequired,
    dirty: PropTypes.bool,
    onMouseDown: PropTypes.func,
    selected: PropTypes.object.isRequired,
    setInsertIndex: PropTypes.func.isRequired,
  };

  onSetDropEffect = (effect: string): void => {
    switch (effect) {
      case DropTargetClass.DROP_EFFECT.ALLOWED:
        this.props.setInsertIndex(this.props.selected.index);
        break;
      default:
        this.props.setInsertIndex(null);
    }
  };

  render(): JSX.Element {
    return (
      <NoteDropTarget
        className={classNames(
          this.props.fullScreen && css(styles.fullScreenHeight),
          !this.props.fullScreen && css(styles.embeddedHeight),
          this.props.fullHeight && css(styles.fullScreenHeight),
          css(styles.noOutline),
          {
            'u-cursor-text': true,
            'noteEditor-catcher': true,
            'u-disable-margin-collapse': true,
            'no-title': this.props.hideTitle,
            // Add padding at the bottom unless we're not editing.
            'padded-catcher': !this.props.locked || this.props.dirty,
          }
        )}
        tabIndex={-1}
        multiple={true}
        locked={this.props.locked}
        isProtected={this.props.isProtected}
        fileId={this.props.fileId}
        handleDropExternalFiles={this.props.insertFilePlaceholderHandler}
        handleDropBenchlingFile={this.props.insertItemHandler}
        onSetDropEffect={this.onSetDropEffect}
        onMouseDown={this.props.onMouseDown}
        hasExistingItem={false}
      >
        {this.props.children}
      </NoteDropTarget>
    );
  }
}

export default NoteCatcher;

const styles = StyleSheet.create({
  fullScreenHeight: {
    minHeight: '100%',
  },
  embeddedHeight: {
    minHeight: NOTE_EDITOR_MIN_HEIGHT,
  },
  noOutline: {
    ':focus': {
      outline: 'none',
    },
  },
});
